import { DeleteButton } from '@/components/Elements/Button'
import { CheckboxCell, SelectCell } from '@/components/Table/components/Cell'
import { Flex } from '@chakra-ui/react'
import { createColumnHelper } from '@tanstack/react-table'
import React from 'react'

const getCostCenterUserTableColumns = ({ removeUser, userOptions = [] }) => {
  const columnHelper = createColumnHelper()

  return [
    {
      accessorKey: 'type',
      header: () => <span>Type</span>,
      cell: (cell) => (
        <SelectCell
          {...cell}
          options={[
            {
              value: '',
              label: '',
            },
            {
              value: 'technical',
              label: 'Technical',
            },
            {
              value: 'commercial',
              label: 'Commercial',
            },
          ]}
        />
      ),
    },
    {
      accessorKey: 'level',
      header: () => <span>Level</span>,

      cell: (cell) => (
        <SelectCell
          {...cell}
          options={[
            {
              value: '',
              label: '',
            },
            {
              value: 3,
              label: '3',
            },
            {
              value: 2,
              label: '2',
            },
            {
              value: 1,
              label: '1',
            },
            {
              value: 0,
              label: '0',
            },
          ]}
        />
      ),
    },
    {
      accessorKey: 'user._id',
      header: () => <span>Name</span>,

      cell: (cell) => <SelectCell {...cell} options={userOptions} />,
    },
    {
      accessorKey: 'user.email',
      header: () => <span>Email</span>,
    },
    {
      accessorKey: 'isDefaultUser',
      header: () => <span>Default</span>,

      cell: (cell) => <CheckboxCell {...cell} />,
    },

    {
      accessorKey: 'isBookingDefaultUser',
      header: () => <span>Booking Default</span>,

      cell: (cell) => <CheckboxCell {...cell} />,
    },
    {
      accessorKey: 'isHighLevelApprovalDefault',
      header: () => <span>Level 2 Or Above Default</span>,

      cell: (cell) => <CheckboxCell {...cell} />,
    },
    {
      id: 'action',
      header: () => <span>Action</span>,

      cell: ({ row: { index } }) => (
        <Flex justifyContent={'center'} w="100%">
          <DeleteButton
            onClick={() => {
              removeUser(index)
            }}
          />
        </Flex>
      ),
    },
  ]
}

export default getCostCenterUserTableColumns
